module.exports = __webpack_public_path__ + "img/2.e8dd6e6d.png";